import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Mixpanel } from "../../utils/mixpanel";
import { Link } from "react-router-dom";

// MUI Imports
import { Button } from '@mui/material';

// Images
import logo from "../../images/logo_all_white.png";
/*
import bkgImage_1 from "../../images/paths/path_1.jpg";
import bkgImage_2 from "../../images/paths/path_2.jpg";
import bkgImage_3 from "../../images/paths/path_3.jpg";
import bkgImage_4 from "../../images/paths/path_4.jpg";
import bkgImage_5 from "../../images/paths/path_5.jpg";
import bkgImage_6 from "../../images/paths/path_6.jpg";
import bkgImage_7 from "../../images/paths/path_7.jpg";
import bkgImage_8 from "../../images/paths/path_8.jpg";
import bkgImage_9 from "../../images/paths/path_9.jpg";
import bkgImage_10 from "../../images/paths/path_10.jpg";
*/
import bkgImage_11 from "../../images/paths/path_11.png";
import bkgImage_12 from "../../images/paths/path_12.png";
import bkgImage_13 from "../../images/paths/path_13.png";

// Constants
const timePerImage = 7000 // wait time (ms) between images
const transitionTime = '3s' // transition time for fading between images

// Styles
const useStyles = makeStyles({
  hero: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '570px',
    width: '100%',
    backgroundColor: '#817d77',
    background: 'linear-gradient(160deg, #3f4244 0%, #7d7773 30%, #9a948e 100%)',
    position: 'relative',
    fontFamily: '"Montserrat", sans-serif',
  },
  logo: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 3,
    margin: '20px',
    height: '65px',
    '& img': {
      height: '100%',
    },
    '@media (max-width: 780px)' : {
      height: '40px'
    }
  },
  logIn: {
    position: 'absolute',
    zIndex: 3,
    top: 0,
    right: 0,
    padding: '20px',
    '& span': {
      color: '#fff'
    }
  },
  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 3
  },
  valueProp: {
    textAlign: 'center',
    padding: '20px',
    zIndex: 1
  },
  title: {
    margin: '0',
    color: '#fff',
    fontSize: '2.8rem',
    '@media (max-width: 780px)' : {
      fontSize: '2.4rem',
    }
  },
  subtitle: {
    margin: "20px 0",
    color: '#dbdbdb',
    fontSize: '1.5rem',
    fontWeight: 600,
  },
  separator: {
    backgroundColor: '#a54c25',
    width: '20%',
    border: '1px solid #E2794B',
    margin: '20px auto'
  },
  bkgImg: {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover', // cover
    transition: `opacity ${transitionTime} ease`,
  },
  cover: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.4)',
  },
  description: {
    margin: "0",
    fontFamily: '"Montserrat", sans-serif',
    color: '#fff',
    lineHeight: '2rem'
  },
  getStartedButton: {
    backgroundColor: '#3c52b2',
    color: '#fff',
    '&:hover': {
      border: '2px solid #fff',
      color: '#fff',
  }}
});

const Hero = (props) => {
  const classes = useStyles();

  const [ bkgImage, setBkgImage ] = useState(0)

  // Array of images to cycle in hero
  const images = [
    //bkgImage_1, bkgImage_2, bkgImage_3, bkgImage_4, bkgImage_5, 
    //bkgImage_6, bkgImage_7, bkgImage_8, bkgImage_9, bkgImage_10, 
    bkgImage_11, bkgImage_12, bkgImage_13
  ]

  useEffect(() => {
    // Init timer for image cycling
    const timer = setTimeout(changeBkgImage, timePerImage)
    return () => {
      clearTimeout(timer);
    };
  }, [bkgImage]);

  const changeBkgImage = () => {
    if (bkgImage < images.length - 1) {
      setBkgImage(bkgImage + 1)
    } else {
      setBkgImage(0)
    }
  }

  const handleClickGetStarted = () => {
    Mixpanel.track("Clicked CTA Button", {
      text: 'Get Started'
    });
    props.history.push("/plans")
  }

  return(
    <div className={classes.hero}>
      <div className={`${classes.cover} ${classes.content}`}>
        <div className={classes.valueProp}>
          <h2 className={`${classes.title}`}> Find Your Path </h2>
          <h3 className={`${classes.subtitle}`}>
            Data-Driven Career Assessments
          </h3>
          <h5 className={`${classes.description}`}>
            Backed by psychology, research, and psychometrics 
          </h5>
          <div className={classes.separator}></div>
          <Button variant="contained" onClick={() => handleClickGetStarted()} size='large' 
            color='whiteButton' 
            className={classes.getStartedButton} sx={{borderRadius: '10px', height: '50px'}}>
            Get Started
          </Button>
        </div>
      </div>

      {/* Logo */}
      <div className={classes.logo}>
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      {/* Log In */}
      <div className={classes.logIn}>
        <Button component={Link} to="/login" size='small' color='blueGrey'>
          Log In
        </Button>
      </div>

      {/* ALL BKG IMAGES */}
      <div className={classes.cover}>
        {images.map((url, index) => (
            <div
              key={index} className={`${classes.cover} ${classes.bkgImg}`}
              style={{
                backgroundImage: `url(${url})`,
                opacity: bkgImage === index ? 1 : 0
              }} />
          ))
        }
      </div>

      {/* Darken Overlay */}
      <div className={`${classes.cover} ${classes.overlay}`} />
    </div>
  )
}

export default Hero;